// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level3 extends TilemapScene {
  constructor() {
    super('Level3');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_3
    const forest_biome_3 = this.add.tilemap('forest-biome-3');
    forest_biome_3.addTilesetImage('summer forest', 'summer forest');
    forest_biome_3.addTilesetImage('summer 48x32', 'summer 48x32');
    forest_biome_3.addTilesetImage(
      'summer forest wang tiles',
      'summer forest wang tiles',
    );
    forest_biome_3.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_3.addTilesetImage(
      'summer trees 80x112',
      'summer trees 80x112',
    );
    forest_biome_3.addTilesetImage('summer 16x32', 'summer 16x32');
    forest_biome_3.addTilesetImage('collision', 'collision & alpha');

    // ground___summer_forest_wang_tiles_1
    forest_biome_3.createLayer(
      'Ground - summer forest wang tiles',
      ['summer forest wang tiles'],
      0,
      0,
    );

    // summer_details_1___summer_48x
    forest_biome_3.createLayer(
      'summer details 1 - summer 48x32',
      ['summer 48x32'],
      0,
      0,
    );

    // ground_details_2___summer_forest_1
    forest_biome_3.createLayer(
      'Ground details 2 - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // shrubbery_1___summer_forest_1
    forest_biome_3.createLayer(
      'Shrubbery 1 - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // shrubbery_2___summer_16x
    forest_biome_3.createLayer(
      'Shrubbery 2 - summer 16x32',
      ['summer 16x32'],
      0,
      0,
    );

    // cliffs_shadows___summer_forest_1
    forest_biome_3.createLayer(
      'Cliffs shadows - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // cliffs___summer_forest_1
    forest_biome_3.createLayer(
      'Cliffs - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = forest_biome_3.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // portal
    const portal = new Portal(this, 433, 212);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 80, 138);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 137, 158);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 184, 141);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(this, 286, 163);
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 361, 142);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, 435, 160);
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      392,
      178,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      229,
      181,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      27,
      122,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      186,
      490,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      253,
      474,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      327,
      493,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      292,
      486,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      130,
      496,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      47,
      167,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      165,
      191,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      328,
      179,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      512,
      211,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      512,
      283,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      552,
      495,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      757,
      434,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      190,
      30,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      46,
      430,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      15,
      497,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      512,
      480,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      736,
      480,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      0,
      224,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      320,
      48,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      464,
      16,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      240,
      528,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(this, 272, 384);
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(this, 80, 496);
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(this, 592, 512);
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(this, 704, 480);
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(this, 432, 32);
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(this, 336, 256, 'summer 32x', 1);
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(this, 208, 304, 'summer 32x', 1);
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(this, 224, 240, 'summer 32x', 0);
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(this, 304, 304, 'summer 32x', 0);
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(this, 352, 288, 'summer 32x', 0);
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(this, 448, 304, 'summer 32x', 2);
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(this, 400, 368, 'summer 32x', 2);
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(this, 352, 464, 'summer 32x', 2);
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(this, 64, 224, 'summer 32x', 2);
    this.add.existing(forestTree_42);

    // forestTree_43
    const forestTree_43 = new ForestTree1(this, 304, 224, 'summer 32x', 2);
    this.add.existing(forestTree_43);

    // forestTree_44
    const forestTree_44 = new ForestTree1(this, 368, 32, 'summer 32x', 2);
    this.add.existing(forestTree_44);

    // forestTree_45
    const forestTree_45 = new ForestTree1(this, 144, 16, 'summer 32x', 2);
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(this, 760, 64, 'summer 48x', 0);
    this.add.existing(forestTree_46);

    // worldNode
    const worldNode = new WorldNode(this, 695, 163);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 553, 230);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 219, 360);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 96, 208);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 382, 402);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 595, 397);
    this.add.existing(worldNode_5);

    // player
    const player = new Player(this, 526, 56);
    this.add.existing(player);

    // mentor
    const mentor = new Mentor1(this, 504, 80);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 360, 240);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 552, 280);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 592, 120);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 664, 304);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 2;
    worldNode.NPCId = 1;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 2;
    worldNode_1.NPCId = 5;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 2;
    worldNode_2.NPCId = 4;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 2;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 2;
    worldNode_4.NPCId = 2;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 2;
    worldNode_5.NPCId = 0;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 2;
    worldNode_6.NPCId = 0;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 2;
    worldNode_7.NPCId = 0;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 2;
    worldNode_8.NPCId = 0;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 2;
    worldNode_9.NPCId = 0;

    this.portal = portal;
    this.player = player;
    this.mentor = mentor;
    this.forest_biome_3 = forest_biome_3;

    this.events.emit('scene-awake');
  }

  private portal!: Portal;
  private player!: Player;
  private mentor!: Mentor1;
  private forest_biome_3!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_3,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
